/**
 * Inbox — Three-pane cockpit (List · Preview · Inspector).
 *
 * Authority: docs/agents/pitch-deck-review/pages/DEAL_EVALUATOR_PAGE_SPEC_V2.md
 *            Section 16 (WI-UI-CLEANUP-001 Stage 2).
 *
 * Replaces the previous single-column card feed + InboxDetailRenderer side
 * sheet. The cockpit is presentational — all data + state live in the
 * useInboxCockpitState hook, which combines the existing inbox + summary
 * fetchers and exposes selectedId + filterTile.
 *
 * The page renders inside CeoOffice's Inbox tab, which calls
 * setFullBleed(true) via LayoutModeContext so AppLayout removes its
 * 840px centered wrapper for the cockpit.
 */

import React from 'react';
import CockpitLayout from '@/components/inbox/cockpit/CockpitLayout';
import { useInboxCockpitState } from '@/components/inbox/cockpit/useInboxCockpitState';

export default function Inbox() {
  const state = useInboxCockpitState();

  return (
    <CockpitLayout
      items={state.items}
      summary={state.summary}
      summaryError={state.summaryError}
      selected={state.selected}
      onSelect={state.setSelectedId}
      filterTile={state.filterTile}
      onFilterTile={state.setFilterTile}
      loading={state.loading}
      error={state.error}
      onRefresh={state.refresh}
      takeawayText={state.takeawayText}
      onAccept={state.onAccept}
      onReject={state.onReject}
      onArticleAction={state.onArticleAction}
      onPassDeal={state.onPassDeal}
      onContacted={state.onContacted}
    />
  );
}
